import React, {useEffect, useState} from "react";
import {MdExpandLess} from '@react-icons/all-files/md/MdExpandLess'
import {MdExpandMore} from '@react-icons/all-files/md/MdExpandMore'
import {FiArchive} from '@react-icons/all-files/fi/FiArchive'
import {BiArchiveOut} from '@react-icons/all-files/bi/BiArchiveOut'
import Switch from "react-switch";
import {useTekstClient} from "hooks/useTekstClient";
import {useSearchParams} from 'next/navigation'
import {useSetSearchParams} from "hooks/useSetSearchParams";
import useSWR from "swr";
import {Form} from "components/ui";
import {BiMinus} from '@react-icons/all-files/bi/BiMinus'
import {useAxios} from "hooks/useAxios";


const useFetchProducten = (metArchief) => {
    const {get} = useAxios();
    return useSWR([`/producten`, metArchief], ([, metArchief]) =>
        get('/producten', { params: { metArchief: metArchief ? 1 : 0, hasWiki: 1 } })
            .then(res => res.data)
            .catch(error => {
                if (error.response.status !== 409) throw error;
            }), {
            refreshInterval: 0,
            revalidateIfStale: false,
            revalidateOnReconnect: true,
            revalidateOnFocus: false,
        }
    );
};

const FilterProduct = ({classToggle, classLine, classSubcheck, prClassName}) => {
    const [expand, setExpand] = useState(true);
    const {tekst} = useTekstClient()
    // const [metArchief, setExpand] = useState(true);
    const [producten, setProducten] = useState([]);
    //const producten = useSelector(state => state.kennisCentrum?.filterProducten); // [array]
    const {
        deleteParams,
        updateParam,
        addParamArrayInt,
        deleteParamArrayInt,
        deleteParamArrayString,
        doMultipleChanges
    } = useSetSearchParams()

    const searchParams = useSearchParams();
    const metArchief = !!searchParams.get('arch')
    const prodParam = searchParams.get('prod')
    const versParam = searchParams.get('vers')
    const productParams = prodParam ? prodParam.split(',').map(x => parseInt(x)) : []
    const versieParams = versParam ? versParam.split(',') : []
    const isReleaseNotes = searchParams.get('inhoud') === 'release'

    const maxAmountVersionsSelected = 3;
    const isMaxAmountVersionsSelected = versieParams.length >= maxAmountVersionsSelected;

    const { data: productenData, isLoading: productenIsLoading } = useFetchProducten(metArchief);


    useEffect(() => {
        if (productenIsLoading || !productenData) return;
        const dataMapped = [...productenData].map(productData => {
            const tmpProduct = {...productData};
            tmpProduct.checked = productParams.includes(productData.id);
            tmpProduct.subChecked = false

            // Opbouw versie & patches
            tmpProduct.versies = [...tmpProduct?.versies].map(versie => {
                const tmpVersie = {...versie};
                // when product and version are in url than show, 
                // because some versions are shared between mkg5 and mkg3 and a 
                // user selects one version both versions will be checked otherwise.
                const isVersieIncluded = tmpProduct.checked && versieParams.some(x => x === versie.versie_zonder_patch);
                tmpProduct.subChecked = tmpProduct.subChecked || isVersieIncluded;

                tmpVersie.checked = isVersieIncluded;

                tmpVersie.patches = [...tmpVersie.patches].map(patch => {
                    const tmpPatch = {...patch};
                    const isPatchIncluded = tmpProduct.checked && versieParams.some(x => x === patch.nr);
                    tmpVersie.subChecked = tmpVersie.subChecked || isPatchIncluded;
                    tmpProduct.subChecked = tmpProduct.subChecked || tmpVersie.subChecked;
                    tmpPatch.checked = isPatchIncluded;
                    tmpVersie.expand = tmpVersie.subChecked || tmpPatch.checked;
                    return tmpPatch;
                });

                tmpVersie.expand = tmpVersie.checked || tmpVersie.subChecked;
                tmpProduct.expand = tmpProduct.expand || tmpVersie.expand;

                return tmpVersie;
            })
            //productData.expand = productData.checked || productData.subChecked ;

            return tmpProduct
        })

        setProducten(dataMapped.sort((a, b) => (a.id === 6 && b.id !== 6) ? 1 : (a.id !== 6 && b.id === 6) ? -1 : 0))
    }, [productenData, prodParam, versParam])


    const handleOnChangeProduct = (checked, product) => {
        if (product.subChecked) {

            // Check which versions and patches are selected and remove them from the QueryParam
            let updateParamsVersie = [...versieParams];
            producten.map(tmpProduct => {
                if (tmpProduct.id === product.id) {
                    tmpProduct.versies.map(tmpVersie => {
                        if (tmpVersie.checked) {
                            updateParamsVersie = updateParamsVersie.filter(x => x !== tmpVersie.versie_zonder_patch).join(',');
                        } else if (tmpVersie.subChecked) {
                            tmpVersie.patches.map(tmpPatch => {
                                if (tmpPatch.checked)
                                    updateParamsVersie = updateParamsVersie.filter(x => x !== tmpPatch.nr).join(',')
                            });
                        }
                    });
                }
            });

            if (updateParamsVersie.length === 0) {
                deleteParams([{name: 'vers'}, {name: 'prod'}])
            } else {
                doMultipleChanges([
                    {fun: 'setParams', params: [{name: 'vers', value: updateParamsVersie}]},
                    {fun: 'deleteParam', params: 'prod'}
                ])
            }
        } else if (checked) {
            addParamArrayInt('prod', product.id)
        } else {
            deleteParamArrayInt('prod', product.id);
        }
    }


    /**
     * indien je de versie veranderd moet het product en patch ook mee.
     * Het kan zijn dat een patch bij zowel mkg3 als mkg5 hoort,
     * deze moeten gescheiden behandeld worden kan je nooit een product aangeven.
     * @param checked
     * @param productId
     * @param versienaam
     */
    const handleOnChangeVersie = (checked, productId, versie) => {
        if (versie.subChecked) {

            // Check which versions and patches are selected and remove them from the QueryParam
            let updateParamsVersie = [...versieParams];
            versie.patches.map(tmpPatch => {
                if (tmpPatch.checked)
                    if (typeof updateParamsVersie === "string") {
                        if (updateParamsVersie === tmpPatch.nr)
                            updateParamsVersie = versie.versie_zonder_patch;

                    } else {
                        updateParamsVersie = updateParamsVersie.filter(x => x !== tmpPatch.nr).join(',')
                    }

            });

            if (updateParamsVersie.length === 0) {
                doMultipleChanges([
                    {fun: 'deleteParam', params: 'vers'},
                    {fun: 'setParams', params: [{name: 'prod', value: productId}]}
                ])
            } else {
                updateParam('vers', updateParamsVersie)
            }
        } else if (checked) {
            doMultipleChanges([
                {fun: 'addParamArrayString', params: {name: 'vers', value: versie.versie_zonder_patch}},
                {fun: 'addParamArrayInt', params: {name: 'prod', value: productId}}
            ])
        } else {
            deleteParamArrayString('vers', versie.versie_zonder_patch);
        }

    }

    const handleOnChangePatch = (checked, versie, patch) => {
        if (checked) {

            // when all paches are check then mark the version as checked and not all patches.
            const allPatchesChecked = !versie.patches.some(x => x.nr !== patch && !x.checked)
            const changesToUrl = [];
            if (allPatchesChecked) {

                versie.patches.map(tmpPatch => {
                    changesToUrl.push({fun: 'deleteParamArrayString', params: {name: 'vers', value: tmpPatch.nr}})
                });
                doMultipleChanges([
                    {fun: 'addParamArrayString', params: {name: 'vers', value: versie.versie_zonder_patch}},
                    {fun: 'addParamArrayInt', params: {name: 'prod', value: versie.pivot.wiki_product_id}},
                    ...changesToUrl
                ])
            } else {
                if ((typeof updateParamsVersie === "string" && updateParamsVersie === versie.versie_zonder_patch)
                    || (typeof updateParamsVersie !== "string" && versieParams?.some(x => x === versie.versie_zonder_patch))) {
                    changesToUrl.push({
                        fun: 'deleteParamArrayString',
                        params: {name: 'vers', value: versie.versie_zonder_patch}
                    })
                }
                doMultipleChanges([
                    {fun: 'addParamArrayString', params: {name: 'vers', value: patch}},
                    {fun: 'addParamArrayInt', params: {name: 'prod', value: versie.pivot.wiki_product_id}},
                    ...changesToUrl
                ])
            }
            //addParamArrayString('vers', patch)
        } else {
            deleteParamArrayString('vers', patch);
        }

    }

    // region Expand/Collapse
    const setProductExpand = (naam, isExpand) => {
        let tmpProducten = [...producten];
        tmpProducten = tmpProducten.map(x => {
            const copyIem = {...x}
            if (copyIem.naam === naam) {
                copyIem.expand = isExpand;
            }
            return copyIem;
        });
        setProducten(tmpProducten)
    }

    const setVersieExpand = (productId, versienaam, isExpand) => {
        let tmpProducten = [...producten];
        tmpProducten = tmpProducten.map(x => {
            const copyItem = {...x}
            if (copyItem.id === productId) {
                copyItem.versies = [...copyItem.versies].map(j => {
                    const copy = {...j}
                    if (copy.versie_zonder_patch === versienaam) {
                        copy.expand = isExpand;
                    }
                    return copy;
                });
            }
            return copyItem;
        });
        setProducten(tmpProducten)
    }
    // endregion Expand


    return <div>
        <div>
            <b className={`flex items-center cursor-pointer`} onClick={() => setExpand(!expand)}>
                {expand
                    ? <MdExpandLess/>
                    : <MdExpandMore/>
                }
                {tekst('pagina:support:kenniscentrum:producten:titel')}
                {isReleaseNotes &&
                    <div className={'float-right toggleArchiefBox ml-28'}>
                        <label title={'Toon archief'}>
                            <Switch
                                checked={metArchief}
                                checkedIcon={<div style={{paddingTop: '1px', marginLeft: '5px'}}><BiArchiveOut/></div>}
                                uncheckedIcon={<div style={{marginLeft: '4px'}}><FiArchive/></div>}
                                onChange={() => {
                                    updateParam('arch', !metArchief ? 1 : 0)
                                }}
                                className={classToggle}
                                height={18}
                                width={40}
                                offColor={'#dee2e6'}
                                onColor={'#23c1f4'}
                            />
                        </label>
                    </div>
                }
                <div className={'clearfix'}/>
            </b>
        </div>
        {expand && <div className={'ml-3'} style={{position: "relative"}}>
            {producten && producten.map(product => {
                return <div key={`prod-${product.id}`}>
                    <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                        {product.subChecked
                            && <div className={classSubcheck} onClick={() => handleOnChangeProduct(true, product)}>
                                <BiMinus/></div>
                        }
                        <Form.Check
                            type={'checkbox'}
                            id={`filter-product-${product.id}`}
                            value={product.id}
                            label={product.naam}
                            onChange={e => handleOnChangeProduct(e.target.checked, product)}
                            // className={props.isReleaseNotes ? 'float-left' : ''}
                            checked={product.checked || false}
                        />
                        {isReleaseNotes &&
                            <div>
                                {product.expand
                                    ?
                                    <MdExpandLess
                                        onClick={() => setProductExpand(product.naam, false)}/>
                                    : <MdExpandMore
                                        onClick={() => setProductExpand(product.naam, true)}/>
                                }
                            </div>
                        }

                    </div>
                    {isReleaseNotes
                        && <div className={'pl-3 pb-3'} style={!product.expand ? {display: 'none'} : {}}>
                            {product.versies.map((versie, k) => {
                                return <div key={`versiebox-${k}`}>
                                    <div style={{position: "relative"}}>
                                        {versie.subChecked && <div className={classSubcheck}
                                                                   onClick={() => handleOnChangeVersie(
                                                                     true,
                                                                     product.id,
                                                                     versie
                                                                   )}>
                                            <BiMinus/></div>}
                                        <Form.Check key={`check-${product.naam}-${versie.versie_zonder_patch}`}
                                                    id={`filter-versie-${product.naam}-${versie.versie_zonder_patch}`}
                                                    className={'float-left'}
                                                    disabled={isMaxAmountVersionsSelected}
                                                    onChange={e => handleOnChangeVersie(
                                                        e.target.checked,
                                                        product.id,
                                                        versie
                                                    )}
                                                    checked={versie.checked}
                                                    label={<span className={prClassName}>{versie.versie_zonder_patch}</span>}
                                        />
                                        <div className={'float-right'}>
                                            {versie.expand
                                                ?
                                                <MdExpandLess
                                                    onClick={() => setVersieExpand(
                                                      product.id,
                                                      versie.versie_zonder_patch,
                                                      false
                                                    )}/>
                                                : <MdExpandMore
                                                    onClick={() => setVersieExpand(
                                                      product.id,
                                                      versie.versie_zonder_patch,
                                                      true
                                                    )}/>
                                            }
                                        </div>
                                        <div className={'clearfix'}/>
                                        <div className={'pl-3'} style={!versie.expand ? {display: 'none'} : {}}>
                                            {versie.patches.map((patch) => {
                                                return <Form.Check key={`check-${patch.id}`}
                                                                   id={`filter-versie-${patch.id}`}
                                                                   disabled={isMaxAmountVersionsSelected}
                                                                   onChange={e => handleOnChangePatch(
                                                                       e.target.checked,
                                                                       versie,
                                                                       patch.nr
                                                                   )}
                                                                   checked={patch.checked}
                                                                   label={<span className={prClassName}>{patch.nr}</span>}
                                                />
                                            })}
                                        </div>

                                    </div>

                                </div>
                            })}
                        </div>}
                </div>
            })}
        </div>}
        <div className={classLine}/>
    </div>
}
export default FilterProduct;
